import React from 'react';
import {Outlet} from 'react-router-dom';
import {AdminLayout} from '../../../layout/admin';
import {DictionaryType} from '../types/DictionaryItem';

const ArtisticObjectSections: React.FC = () => {
  return (
    <AdminLayout>
      <Outlet context={{
        dictionaryType: DictionaryType.ARTISTIC_OBJECT_SECTION,
        indexPath: '/artistic-object-sections'
      }}/>
    </AdminLayout>
  );
};

export default ArtisticObjectSections;
